export const CLIENTS = [
    { src: 'elastotech.png', alt:'elastotech Logo' },
    { src: 'ADF.png', alt:'ADF Logo' },
    { src: 'b2rhconseil.png', alt:'b2rhconseil Logo' },
    { src: 'normandie.png', alt:'normandie Logo' },
    { src: 'one.png', alt:'one Logo' },
    /* { src: 'poleEmploi.png', alt:'poleEmploi Logo' }, */
    { src: 'franceTravail.png', alt: 'France travail Logo' },
    { src: 'interimQualite.png', alt:'interimQualite Logo' },
    /* { src: 'MDE.png', alt:'MDE Logo' }, */
    { src: 'Afpa.png', alt: 'Afpa Logo' },
    { src: 'OLEUM.png', alt: 'OLEUM Logo' },
    { src: 'soprovise.png', alt:'soprovise Logo' },
    { src: 'CFM.png', alt:'CFM Logo' },
    { src: 'STA.png', alt:'STA Logo' },
    { src: 'IS.png', alt:'IS Logo' },
    { src: 'IN2IN.png', alt:'IN2IN Logo' },
]